import { InjectionToken } from '@angular/core';
import { ModuleConfig } from '@inshuwa-client/models';

export const devBaseUrl = 'https://api-dev.inshuwa.com/api/v1';
  // export const devBaseUrl = 'https://api.inshuwa.com/api/v1';
// export const devBaseUrl = 'http://localhost:5095/api/v1';
// export const devBaseUrl = 'https://localhost:7026/api/v1';
// export const liveBaseUrl = 'https://api.inshuwa.com/api/v1';
export const liveBaseUrl = 'https://api.inshuwa.com/api/v1';

// Partner API hosts, from InshuwaPlatform Deployment/inshuwa-dev-stack.yml and inshuwa-stack.yml
export const devPartnerApiUrl = 'https://partner-dev-api.inshuwa.com';
export const livePartnerApiUrl = 'https://partner-api.inshuwa.com';

export const ConfigInjectionToken = new InjectionToken<ModuleConfig>('configs');
export const MicroInsuranceProduct = {
  StatedBenefit: 'mutendere',
  General: 'General',
  All: 'All',
};
